'use client';

import { c as _c } from "react/compiler-runtime";
import { Box, ClickAwayListener, type TooltipProps } from '@mui/material';
import { useRef, useState } from 'react';
import type { InfoTooltipProps } from './types';
import TooltipTrigger from './TooltipTrigger';
import { NwTooltip } from './NwTooltip';
export interface NWTooltipProps extends TooltipProps {
  maxWidth?: string | number;
}
export const ControlInfoTooltip = t0 => {
  const $ = _c(38);
  const {
    position: t1,
    text,
    children,
    ariaLabel,
    maxWidth: t2,
    trigger,
    minHeight,
    minWidth,
    containerStyles,
    onOpen,
    onClose,
    onBlur,
    rounded,
    triggerIconHeight,
    triggerIconWidth,
    tooltipColor,
    tooltipPadding
  } = t0;
  const position = t1 === undefined ? "top" : t1;
  const maxWidth = t2 === undefined ? 240 : t2;
  const [isOpen, setIsOpen] = useState(false);
  const tooltipRef = useRef(null);
  const handleContainerClick = _temp;
  if (!text && !children) {
    return null;
  }
  let t3;
  if ($[0] !== isOpen || $[1] !== onBlur) {
    t3 = e_0 => {
      if (isOpen && tooltipRef.current && !tooltipRef.current.contains(e_0.target as Node)) {
        setIsOpen(false);
        if (onBlur) {
          onBlur();
        }
      }
    };
    $[0] = isOpen;
    $[1] = onBlur;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== containerStyles) {
    t4 = {
      display: "inline-block",
      ...containerStyles
    };
    $[3] = containerStyles;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = text ?? children;
  let t6;
  if ($[5] !== rounded) {
    t6 = rounded && {
      border: "1px solid",
      borderColor: "grey.100",
      borderRadius: "20px",
      "& .MuiTooltip-arrow::before": {
        borderColor: "grey.100"
      }
    };
    $[5] = rounded;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== tooltipPadding) {
    t7 = tooltipPadding && {
      padding: tooltipPadding
    };
    $[7] = tooltipPadding;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = {
      mx: 3,
      ...t6,
      ...t7
    };
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== isOpen || $[13] !== onClose || $[14] !== onOpen) {
    t9 = () => {
      if (!isOpen && onOpen) {
        onOpen();
      }
      if (isOpen && onClose) {
        onClose();
      }
      setIsOpen(!isOpen);
    };
    $[12] = isOpen;
    $[13] = onClose;
    $[14] = onOpen;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== ariaLabel || $[17] !== minHeight || $[18] !== minWidth || $[19] !== t9 || $[20] !== tooltipColor || $[21] !== trigger || $[22] !== triggerIconHeight || $[23] !== triggerIconWidth) {
    t10 = <TooltipTrigger onTriggerToggle={t9} arialLabel={ariaLabel} minHeight={minHeight} minWidth={minWidth} triggerIconHeight={triggerIconHeight} triggerIconWidth={triggerIconWidth} color={tooltipColor}>{trigger}</TooltipTrigger>;
    $[16] = ariaLabel;
    $[17] = minHeight;
    $[18] = minWidth;
    $[19] = t9;
    $[20] = tooltipColor;
    $[21] = trigger;
    $[22] = triggerIconHeight;
    $[23] = triggerIconWidth;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== isOpen || $[26] !== maxWidth || $[27] !== position || $[28] !== t10 || $[29] !== t5 || $[30] !== t8) {
    t11 = <NwTooltip title={t5} placement={position} arrow={true} sx={t8} open={isOpen} maxWidth={maxWidth}>{t10}</NwTooltip>;
    $[25] = isOpen;
    $[26] = maxWidth;
    $[27] = position;
    $[28] = t10;
    $[29] = t5;
    $[30] = t8;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t11 || $[33] !== t4) {
    t12 = <Box ref={tooltipRef} onClick={handleContainerClick} component="span" sx={t4}>{t11}</Box>;
    $[32] = t11;
    $[33] = t4;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t12 || $[36] !== t3) {
    t13 = <ClickAwayListener mouseEvent="onMouseDown" onClickAway={t3}>{t12}</ClickAwayListener>;
    $[35] = t12;
    $[36] = t3;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  return t13;
};
function _temp(e) {
  e.stopPropagation();
}